import React from "react";
import Router from "next/router";

import { Localized } from "fluent-react/compat";

const style = {
  backgroundColor: "#e8424b",
  fontSize: "20px",
};

const ButtonSeeCart = ({ screenDesktop }) => {
  const handler = () => {
    Router.push(
      "/commande-en-ligne/[idRestaurant]/carte",
      `/commande-en-ligne/${Router.query.idRestaurant}/carte`
    );
  };
  return (
    <div className="container-action-page">
      <div className="button-action-page">
        <Localized id="tr-button-see-cart">
          {screenDesktop ? (
            <span onClick={() => handler()} className="animated zoomIn" />
          ) : (
            <button
              onClick={() => handler()}
              className="button-arround animated zoomIn"
              style={style}
            />
          )}
        </Localized>
      </div>
    </div>
  );
};

export default ButtonSeeCart;
